import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarSmall = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 2,
		y: 2,
		width: 20,
		height: 20,
		stroke: "currentColor",
		strokeWidth: 3,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 2,
		y1: 7.5,
		x2: 22,
		y2: 7.5,
		stroke: "currentColor",
		strokeWidth: 3
	})]
});
const ForwardRef = forwardRef(SvgCalendarSmall);
export default ForwardRef;
